type ResetOnboardingDebugStateArgs = {
  isDesktop: boolean;
  appName: string;
  resetTccAndClearCache: (args: { appName: string }) => Promise<void>;
  recreateAccountCache: () => Promise<void>;
  debugResetAll: () => Promise<void>;
};

/**
 * Resets onboarding while preserving state that must survive the following reload.
 *
 * Desktop cache clearing must finish first because the onboarding reset writes
 * the explicit Proactive trial debug override into that cache.
 */
export const resetOnboardingDebugState = async ({
  isDesktop,
  appName,
  resetTccAndClearCache,
  recreateAccountCache,
  debugResetAll,
}: ResetOnboardingDebugStateArgs): Promise<void> => {
  if (isDesktop) {
    await resetTccAndClearCache({ appName });
    await recreateAccountCache();
  }

  await debugResetAll();
};
